import { useSelector } from 'react-redux'

import FeesCalculator from './FeesCalculator'

const FeesCalculatorContainer = props => {
  const urlData = useSelector(({ url }) => url)

  const updatedProps = {
    ...props,
    ...urlData
  }

  return <FeesCalculator {...updatedProps} />
}

export default FeesCalculatorContainer
